import request from '../request'

/**
 * 获取投标申请列表
 */
export function getBidApplyList(params) {
    return request({
        url: '/market-service/scrm/project/bid/apply/list',
        method: 'GET',
        params,
    })
}

/**
 * 新增投标申请
 */
export function addBidApply(data) {
    return request({
        url: '/market-service/scrm/project/bid/apply/add',
        method: 'POST',
        data,
    })
}

/**
 * 修改投标申请
 */
export function updateBidApply(data) {
    return request({
        url: '/market-service/scrm/project/bid/apply/update',
        method: 'POST',
        data,
    })
}/**
 * 修改投标申请
 */
export function resubmitBidApply(data) {
    return request({
        url: '/market-service/scrm/project/bid/apply/resubmit',
        method: 'POST',
        data,
    })
}

/**
 * 删除投标申请
 */
export function deleteBidApply(id) {
    return request({
        url: `/market-service/scrm/project/bid/apply/delete/${id}`,
        method: 'POST',
    })
}

/**
 * 获取投标申请详情
 */
export function getBidApplyDetail(id) {
    return request({
        url: `/market-service/scrm/project/bid/apply/query/${id}`,
        method: 'GET',
    })
}

/**
 * 根据项目ID获取投标申请
 */
export function getBidApplyByProject(projectId) {
    return request({
        url: `/market-service/scrm/project/bid/apply/queryByProject/${projectId}`,
        method: 'GET',
    })
}